export const ZONE0 = {
  data () {
    return {
      dataInfo: []
    }
  },
  mounted () {
    this.dataInfo = [{
      isEdit: true,
      id: 0,
      zone: {
        value: '0'
      },
      descr: {
        value: 'All Groups',
        type: 'input',
        disabled: true,
        maxlength: 32,
        change: (data, rowData, index) => {
          const value = data.value
          if (value.length > 32) {
            this.$message.error(this.$t('tooLong'))
            data.value = value.substr(0, 32)
          }
          this.addDataToArr(rowData, index)
        }
      },
      groupBySndCK: {
        value: this.$t('yes'),
        type: 'select',
        width: 80,
        options: this.yesOrNo,
        change: (data, rowData, index) => {
          this.addDataToArr(rowData, index,'groupBySndCK')
        }
      },
    }]
  }
}
